"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchResultTabsConfig = void 0;
const app_1 = require("app");
const Tile_1 = require("Views/Partials/Components/Tile");
const typings_1 = require("./typings");
exports.searchResultTabsConfig = [
    {
        key: typings_1.SearchResultTabKeyEnum.Pages,
        title: 'Pages',
        tileType: Tile_1.TileTypeEnum.Page,
        source: 'pages',
        attributes: [
            {
                label: 'Business unit',
                isHidden: false,
                key: 'data.danfossSegment',
                type: app_1.FilterTypeEnum.MultiSelect,
                guiType: app_1.FilterGuiTypeEnum.Checkbox,
            },
            {
                label: 'Page types',
                isHidden: false,
                key: 'contentTypeAlias',
                type: app_1.FilterTypeEnum.SingleSelect,
                guiType: app_1.FilterGuiTypeEnum.Radio,
            },
        ],
    },
    {
        key: typings_1.SearchResultTabKeyEnum.Products,
        title: 'Products',
        tileType: Tile_1.TileTypeEnum.Product,
        source: 'products',
        attributes: [
            {
                label: 'Business unit',
                isHidden: false,
                key: 'segments',
                type: app_1.FilterTypeEnum.SingleSelect,
                guiType: app_1.FilterGuiTypeEnum.Radio,
                gtmKey: 'productsSegment',
            },
        ],
    },
    {
        key: typings_1.SearchResultTabKeyEnum.Documents,
        title: 'Documents',
        tileType: Tile_1.TileTypeEnum.Document,
        source: 'assets',
        assetsKey: typings_1.SearchResultAssetKey.Documents,
        attributes: [
            {
                label: 'Asset Type',
                isHidden: true,
                key: 'assetType',
                type: app_1.FilterTypeEnum.MultiSelect,
            },
            {
                key: 'publicationChannelDefinitionIds',
                label: 'Publication Channel',
                isHidden: true,
                type: app_1.FilterTypeEnum.SingleSelect,
            },
            {
                key: 'segments',
                label: 'Business unit',
                isHidden: false,
                type: app_1.FilterTypeEnum.SingleSelect,
                guiType: app_1.FilterGuiTypeEnum.Radio,
                gtmKey: 'documentationSegment',
            },
            {
                label: 'Document types',
                isHidden: false,
                key: 'assetSubType',
                type: app_1.FilterTypeEnum.MultiSelect,
                guiType: app_1.FilterGuiTypeEnum.Checkbox,
                gtmKey: 'documentationDocumentType',
            },
            {
                label: 'Approval types',
                isHidden: false,
                key: 'assetSubSubType',
                type: app_1.FilterTypeEnum.MultiSelect,
                guiType: app_1.FilterGuiTypeEnum.Checkbox,
                dependentOn: 'assetSubType',
                gtmKey: 'documentationApprovalType',
            },
            {
                label: 'All languages',
                isHidden: false,
                key: 'languages',
                type: app_1.FilterTypeEnum.MultiSelect,
                guiType: app_1.FilterGuiTypeEnum.Checkbox,
                gtmKey: 'documentationLanguage',
            },
            {
                label: 'All countries/regions',
                mobileLabel: 'Valid for',
                isHidden: false,
                key: 'countries',
                type: app_1.FilterTypeEnum.SingleSelect,
                guiType: app_1.FilterGuiTypeEnum.Dropdown,
                gtmKey: 'documentationCountry',
            },
            {
                label: 'Status',
                isHidden: false,
                key: 'status',
                type: app_1.FilterTypeEnum.SingleSelect,
                guiType: app_1.FilterGuiTypeEnum.Radio,
                gtmKey: 'documentationStatus',
            },
        ],
        hierarchicalAttributes: {
            DCS: [
                {
                    label: 'Level 1',
                    mobileLabel: 'Product hierarchy',
                    key: 'hierarchies.DCS.level1',
                    isHidden: false,
                    type: app_1.FilterTypeEnum.HierarchySelect,
                    guiType: app_1.FilterGuiTypeEnum.Hierarchy,
                    gtmKey: 'documentationProductHierarchy',
                },
                {
                    label: 'Level 2',
                    mobileLabel: '',
                    key: 'hierarchies.DCS.level2',
                    isHidden: false,
                    type: app_1.FilterTypeEnum.HierarchySelect,
                    guiType: app_1.FilterGuiTypeEnum.Hierarchy,
                    gtmKey: 'documentationProductHierarchy',
                },
                {
                    label: 'Level 3',
                    mobileLabel: '',
                    key: 'hierarchies.DCS.level3',
                    isHidden: false,
                    type: app_1.FilterTypeEnum.HierarchySelect,
                    guiType: app_1.FilterGuiTypeEnum.Hierarchy,
                    gtmKey: 'documentationProductHierarchy',
                },
                {
                    label: 'Level 4',
                    mobileLabel: '',
                    key: 'hierarchies.DCS.level4',
                    isHidden: false,
                    type: app_1.FilterTypeEnum.HierarchySelect,
                    guiType: app_1.FilterGuiTypeEnum.Hierarchy,
                    gtmKey: 'documentationProductHierarchy',
                },
                {
                    label: 'Level 5',
                    mobileLabel: '',
                    key: 'hierarchies.DCS.level5',
                    isHidden: false,
                    type: app_1.FilterTypeEnum.HierarchySelect,
                    guiType: app_1.FilterGuiTypeEnum.Hierarchy,
                    gtmKey: 'documentationProductHierarchy',
                },
                {
                    label: 'Level 6',
                    mobileLabel: '',
                    key: 'hierarchies.DCS.level6',
                    isHidden: false,
                    type: app_1.FilterTypeEnum.HierarchySelect,
                    guiType: app_1.FilterGuiTypeEnum.Hierarchy,
                    gtmKey: 'documentationProductHierarchy',
                },
                {
                    label: 'Level 7',
                    mobileLabel: '',
                    key: 'hierarchies.DCS.level7',
                    isHidden: false,
                    type: app_1.FilterTypeEnum.HierarchySelect,
                    guiType: app_1.FilterGuiTypeEnum.Hierarchy,
                    gtmKey: 'documentationProductHierarchy',
                },
            ],
            DPD: [
                {
                    label: 'Level 1',
                    key: 'hierarchies.DPD.level1',
                    isHidden: false,
                    type: app_1.FilterTypeEnum.HierarchySelect,
                    guiType: app_1.FilterGuiTypeEnum.Hierarchy,
                    gtmKey: 'documentationProductHierarchy',
                },
                {
                    label: 'Level 2',
                    key: 'hierarchies.DPD.level2',
                    isHidden: false,
                    type: app_1.FilterTypeEnum.HierarchySelect,
                    guiType: app_1.FilterGuiTypeEnum.Hierarchy,
                    gtmKey: 'documentationProductHierarchy',
                },
                {
                    label: 'Level 3',
                    key: 'hierarchies.DPD.level3',
                    isHidden: false,
                    type: app_1.FilterTypeEnum.HierarchySelect,
                    guiType: app_1.FilterGuiTypeEnum.Hierarchy,
                    gtmKey: 'documentationProductHierarchy',
                },
                {
                    label: 'Level 4',
                    key: 'hierarchies.DPD.level4',
                    isHidden: false,
                    type: app_1.FilterTypeEnum.HierarchySelect,
                    guiType: app_1.FilterGuiTypeEnum.Hierarchy,
                    gtmKey: 'documentationProductHierarchy',
                },
            ],
            DPS: [
                {
                    label: 'Level 1',
                    mobileLabel: 'Product hierarchy',
                    key: 'hierarchies.DPS.level1',
                    isHidden: false,
                    type: app_1.FilterTypeEnum.HierarchySelect,
                    guiType: app_1.FilterGuiTypeEnum.Hierarchy,
                    gtmKey: 'documentationProductHierarchy',
                },
                {
                    label: 'Level 2',
                    mobileLabel: '',
                    key: 'hierarchies.DPS.level2',
                    isHidden: false,
                    type: app_1.FilterTypeEnum.HierarchySelect,
                    guiType: app_1.FilterGuiTypeEnum.Hierarchy,
                    gtmKey: 'documentationProductHierarchy',
                },
                {
                    label: 'Level 3',
                    mobileLabel: '',
                    key: 'hierarchies.DPS.level3',
                    isHidden: false,
                    type: app_1.FilterTypeEnum.HierarchySelect,
                    guiType: app_1.FilterGuiTypeEnum.Hierarchy,
                    gtmKey: 'documentationProductHierarchy',
                },
                {
                    label: 'Level 4',
                    mobileLabel: '',
                    key: 'hierarchies.DPS.level4',
                    isHidden: false,
                    type: app_1.FilterTypeEnum.HierarchySelect,
                    guiType: app_1.FilterGuiTypeEnum.Hierarchy,
                    gtmKey: 'documentationProductHierarchy',
                },
                {
                    label: 'Level 5',
                    mobileLabel: '',
                    key: 'hierarchies.DPS.level5',
                    isHidden: false,
                    type: app_1.FilterTypeEnum.HierarchySelect,
                    guiType: app_1.FilterGuiTypeEnum.Hierarchy,
                    gtmKey: 'documentationProductHierarchy',
                },
                {
                    label: 'Level 6',
                    mobileLabel: '',
                    key: 'hierarchies.DPS.level6',
                    isHidden: false,
                    type: app_1.FilterTypeEnum.HierarchySelect,
                    guiType: app_1.FilterGuiTypeEnum.Hierarchy,
                    gtmKey: 'documentationProductHierarchy',
                },
                {
                    label: 'Level 7',
                    mobileLabel: '',
                    key: 'hierarchies.DPS.level7',
                    isHidden: false,
                    type: app_1.FilterTypeEnum.HierarchySelect,
                    guiType: app_1.FilterGuiTypeEnum.Hierarchy,
                    gtmKey: 'documentationProductHierarchy',
                },
                {
                    label: 'Level 8',
                    mobileLabel: '',
                    key: 'hierarchies.DPS.level8',
                    isHidden: false,
                    type: app_1.FilterTypeEnum.HierarchySelect,
                    guiType: app_1.FilterGuiTypeEnum.Hierarchy,
                    gtmKey: 'documentationProductHierarchy',
                },
            ],
        },
        preselectedRefinements: {
            assetType: ['Document', 'Approval'],
            status: ['Published'],
            publicationChannelDefinitionIds: ['1105'],
        },
    },
    {
        key: typings_1.SearchResultTabKeyEnum.Drawings,
        title: 'Drawings',
        tileType: Tile_1.TileTypeEnum.Document,
        source: 'assets',
        assetsKey: typings_1.SearchResultAssetKey.Drawings,
        attributes: [
            {
                label: 'Asset Type',
                isHidden: true,
                key: 'assetType',
                type: app_1.FilterTypeEnum.MultiSelect,
            },
            {
                key: 'publicationChannelDefinitionIds',
                label: 'Publication Channel',
                isHidden: true,
                type: app_1.FilterTypeEnum.SingleSelect,
            },
            {
                label: 'Business unit',
                isHidden: false,
                key: 'segments',
                type: app_1.FilterTypeEnum.SingleSelect,
                guiType: app_1.FilterGuiTypeEnum.Radio,
                gtmKey: 'drawingsSegment',
            },
            {
                label: 'Drawing types',
                isHidden: false,
                key: 'assetSubType',
                type: app_1.FilterTypeEnum.MultiSelect,
                guiType: app_1.FilterGuiTypeEnum.Checkbox,
                gtmKey: 'drawingsDrawingType',
            },
            {
                label: 'All languages',
                isHidden: false,
                key: 'languages',
                type: app_1.FilterTypeEnum.MultiSelect,
                guiType: app_1.FilterGuiTypeEnum.Checkbox,
                gtmKey: 'drawingsLanguage',
            },
            {
                label: 'Status',
                isHidden: false,
                key: 'status',
                type: app_1.FilterTypeEnum.SingleSelect,
                guiType: app_1.FilterGuiTypeEnum.Radio,
                gtmKey: 'drawingsStatus',
            },
        ],
        hierarchicalAttributes: {
            DPD: [
                {
                    label: 'Level 1',
                    key: 'hierarchies.DPD.level1',
                    isHidden: false,
                    type: app_1.FilterTypeEnum.HierarchySelect,
                    guiType: app_1.FilterGuiTypeEnum.Hierarchy,
                    gtmKey: 'drawingsProductHierarchy',
                },
                {
                    label: 'Level 2',
                    key: 'hierarchies.DPD.level2',
                    isHidden: false,
                    type: app_1.FilterTypeEnum.HierarchySelect,
                    guiType: app_1.FilterGuiTypeEnum.Hierarchy,
                    gtmKey: 'drawingsProductHierarchy',
                },
                {
                    label: 'Level 3',
                    key: 'hierarchies.DPD.level3',
                    isHidden: false,
                    type: app_1.FilterTypeEnum.HierarchySelect,
                    guiType: app_1.FilterGuiTypeEnum.Hierarchy,
                    gtmKey: 'drawingsProductHierarchy',
                },
                {
                    label: 'Level 4',
                    key: 'hierarchies.DPD.level4',
                    isHidden: false,
                    type: app_1.FilterTypeEnum.HierarchySelect,
                    guiType: app_1.FilterGuiTypeEnum.Hierarchy,
                    gtmKey: 'drawingsProductHierarchy',
                },
            ],
        },
        preselectedRefinements: {
            assetType: ['Drawing'],
            publicationChannelDefinitionIds: ['1105'],
        },
    },
    {
        key: typings_1.SearchResultTabKeyEnum.Downloads,
        title: 'Downloads',
        tileType: Tile_1.TileTypeEnum.Download,
        source: 'assets',
        assetsKey: typings_1.SearchResultAssetKey.Softwares,
        attributes: [
            {
                key: 'assetType',
                label: 'Asset Type',
                isHidden: true,
                type: app_1.FilterTypeEnum.MultiSelect,
            },
            {
                key: 'publicationChannelDefinitionIds',
                label: 'Publication Channel',
                isHidden: true,
                type: app_1.FilterTypeEnum.SingleSelect,
            },
            {
                key: 'segments',
                label: 'Business unit',
                isHidden: false,
                type: app_1.FilterTypeEnum.SingleSelect,
                guiType: app_1.FilterGuiTypeEnum.Radio,
                gtmKey: 'downloadSegment',
            },
            {
                key: 'assetSubType',
                label: 'Software types',
                isHidden: false,
                type: app_1.FilterTypeEnum.MultiSelect,
                guiType: app_1.FilterGuiTypeEnum.Checkbox,
                gtmKey: 'downloadSoftwareType',
            },
            {
                key: 'softwareCharacteristicDefinitionIds',
                label: 'Software Characteristic',
                isHidden: false,
                type: app_1.FilterTypeEnum.MultiSelect,
                guiType: app_1.FilterGuiTypeEnum.Checkbox,
                dependentOn: 'assetSubType',
            },
        ],
        hierarchicalAttributes: {
            DPD: [
                {
                    label: 'Level 1',
                    key: 'hierarchies.DPD.level1',
                    isHidden: false,
                    type: app_1.FilterTypeEnum.HierarchySelect,
                    guiType: app_1.FilterGuiTypeEnum.Hierarchy,
                    gtmKey: 'downloadProductHierarchy',
                },
                {
                    label: 'Level 2',
                    key: 'hierarchies.DPD.level2',
                    isHidden: false,
                    type: app_1.FilterTypeEnum.HierarchySelect,
                    guiType: app_1.FilterGuiTypeEnum.Hierarchy,
                    gtmKey: 'downloadProductHierarchy',
                },
                {
                    label: 'Level 3',
                    key: 'hierarchies.DPD.level3',
                    isHidden: false,
                    type: app_1.FilterTypeEnum.HierarchySelect,
                    guiType: app_1.FilterGuiTypeEnum.Hierarchy,
                    gtmKey: 'downloadProductHierarchy',
                },
                {
                    label: 'Level 4',
                    key: 'hierarchies.DPD.level4',
                    isHidden: false,
                    type: app_1.FilterTypeEnum.HierarchySelect,
                    guiType: app_1.FilterGuiTypeEnum.Hierarchy,
                    gtmKey: 'downloadProductHierarchy',
                },
            ],
        },
        preselectedRefinements: {
            assetType: ['Software'],
            publicationChannelDefinitionIds: ['1105'],
        },
    },
];
